import React from 'react';
import { Link } from 'react-router-dom';


const Logo = ({limage, dimage, simage}) => {
    return (
        <Link to={ "/"}>
            <img className="light-version-logo" src={process.env.PUBLIC_URL + limage} alt="logo" style={{maxHeight:"10vh"}}/>
            <img className="dark-version-logo" src={process.env.PUBLIC_URL + dimage} alt="logo" style={{maxHeight:"10vh"}}/>
            <img className="sticky-logo" src={process.env.PUBLIC_URL + simage} alt="logo" style={{maxHeight:"10vh"}}/>
        </Link>
    )
}


export default Logo;